import * as React from "react";
import { IReduxProps, IOwnProps, PlanMetricRows } from "../pinned-row-constants";
import { getColumnComponent } from "./plan-metric-helpers";
import { getPlanRowType, setCurrency } from "../pinned-row-helpers";
export const PlanMetricRenderer: React.FunctionComponent<IReduxProps & IOwnProps> = ({
    colDef,
    kind,
    node,
    columnApi,
    style,
    allocationReferenceFields,
    total,
    plan,
    totalType,
}) => {
    const fieldName = colDef.colId;
    const planRowType = getPlanRowType(node.rowIndex);
    const Component = getColumnComponent(kind, fieldName);
    let currency;
    if (planRowType === PlanMetricRows.Total) {
        currency = setCurrency(
            totalType,
            allocationReferenceFields,
            columnApi,
            !!colDef?.cellRendererParams?.doors,
            kind,
            colDef.cellRendererParams.currency
        );
    }
    return (
        <Component
            totalType={totalType}
            planRowType={planRowType}
            total={total}
            plan={plan}
            style={style}
            currency={currency}
        />
    );
};
